if (!customElements.get("video-marquee")) {
	class VideoMarquee extends HTMLElement {
		constructor() {
			super();
			this.swiper = null;
 		}

		connectedCallback() {
			this.addEventListener("youtube:state:change", (e) => this.handleVideoStateChange(e));
			this.initializeSwiper();
			this.swiperElement = this.querySelector(".swiper");
			// this.swiperElement.addEventListener('youtube:state:change', (e) => this.handleVideoStateChange(e));
		}

		handleVideoStateChange(event) {
			const { state, videoElement } = event.detail;
			const shouldPause = state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING;

			if (shouldPause) {
				this.swiper.autoplay.stop();
 			} else {
				this.swiper.autoplay.start();
 			}

			if (state === YT.PlayerState.PLAYING) {
				const currentlyPlaying = this.querySelector("youtube-video.is-playing");
				if (currentlyPlaying && currentlyPlaying !== videoElement) {
					currentlyPlaying.player.pauseVideo();
					currentlyPlaying.classList.remove("is-playing");
				}
				videoElement.classList.add("is-playing");
			} else if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
				videoElement.classList.remove("is-playing");
			}
		}

		initializeSwiper() {
			const el = this.querySelector(".video-marquee-swiper");
			const scrollbarEl = this.querySelector(".video-marquee-swiper-scrollbar");
			const speed = parseInt(el.dataset.autoplaySpeed) || 5000;
			const delay = parseInt(el.dataset.autoplayDelay) || 5000;
			this.swiper = new Swiper(el, {
				slidesPerView: "auto",
        navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				spaceBetween: 8,
				autoplay: {
					speed,
					delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				allowTouchMove: true,
				scrollbar: {
					el: scrollbarEl,
					draggable: true,
				}
      });
 		}
	}
	customElements.define("video-marquee", VideoMarquee);
}
